export enum PassTargetTypeEnum {
  COURSE = 'COURSE'
}
